module.exports = __webpack_public_path__ + "static/media/bg.2d8cac5c.png";